import React from "react";
import {getCommonVisualizerType} from "../../../../config";

const LookIntroAIImageChange = (props) => {

  const {isHidden, isMobile} = props;

  const isBathroom = getCommonVisualizerType() === "bathroom";
  const image1 = isBathroom ? "bv-after.jpg" : "ChatGPT_ai_image_1.png";
  const image2 = isBathroom ? "bv-before.jpg" : "ChatGPT_ai_image_2.png";

  return (
    <div className={"flex flex--center"
      + (isHidden ? " absolute opacity-0 u-right-full transition2 visibility-hidden" : "")
      + (isMobile ? " fixed u-h-full u-left-4 u-top-0" : " u-pb-05")} style={isMobile ? {width: "calc(50% - 4rem)"} : null}>
      <div className={"relative" + (isMobile ? " u-h-full u-w-full" : "")}>
        <img className={"look-intro__ai-image" + (isMobile ? " u-h-full u-w-full" : "")}
             src={`https://qc-cdn.s3.dualstack.us-east-1.amazonaws.com/look/${image2}`} alt=""/>
        <img className={"look-intro__ai-image look-intro__ai-image--animation absolute u-left-0 u-top-0 u-w-full u-h-full"}
             src={`https://qc-cdn.s3.dualstack.us-east-1.amazonaws.com/look/${image1}`} alt=""/>
      </div>
    </div>
  )
};

export default LookIntroAIImageChange
